/**
 * How long a piece of audio lasts, read from its own header.
 *
 * Whole seconds, or 0 when the browser cannot tell — a stream with no length,
 * a format it does not read, or no answer within `timeoutMs`. Callers treat 0
 * as "unknown" rather than as silence.
 */
export function probeAudioDuration(source: Blob | string, timeoutMs = 10_000): Promise<number> {
    return new Promise((resolve) => {
        const url = typeof source === "string" ? source : URL.createObjectURL(source);
        const probe = new Audio();
        let settled = false;
        const finish = (seconds: number) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            probe.removeAttribute("src");
            if (typeof source !== "string") URL.revokeObjectURL(url);
            resolve(Number.isFinite(seconds) && seconds > 0 ? Math.round(seconds) : 0);
        };
        const timer = setTimeout(() => finish(0), timeoutMs);
        probe.preload = "metadata";
        probe.onloadedmetadata = () => finish(probe.duration);
        probe.onerror = () => finish(0);
        probe.src = url;
    });
}
